import Navbar from "./NavBar";
import styles from "../../styles/common/error404.module.css";
import { Paper } from "@mui/material";

export default function Error404() {
  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <Paper elevation={5} className={styles.errorContainer}>
          <h1>404 Page Not Found !</h1>
          <p>Add a page with this route to show here</p>
        </Paper>
      </div>
    </>
  );
}